import MaterialIcons from 'react-native-vector-icons/MaterialIcons';
import FontAwesome5 from 'react-native-vector-icons/FontAwesome5';
import MaterialCommunityIcons from 'react-native-vector-icons/MaterialCommunityIcons';
import React, { memo, useCallback, useEffect, useRef, useState } from 'react';
import {
  FlatList,
  Image,
  ImageBackground,
  Linking,
  TouchableWithoutFeedback,
  View,
  Clipboard,
  ActivityIndicator,
  TouchableOpacity,
  Dimensions,
} from 'react-native';
import {
  GiftedChat,
  IMessage,
  Send,
  SendProps,
  Bubble,
  InputToolbar,
  Composer,
  ComposerProps,
  SystemMessage,
  Day,
  Time,
  // MessageImage,
} from 'react-native-gifted-chat';
import TypingIndicator from 'react-native-gifted-chat/lib/TypingIndicator';
import { SafeAreaView } from 'react-native-safe-area-context';
import AccessoryBar from './example-expo/AccessoryBar';
import {
  Button,
  Container,
  Line,
  Typography,
  SelectedMessage,
  Spacing,
  MyModal,
  ScrollingView,
} from 'components/src';
import { ChatHeader, Pin, Replay } from '../../molecules';
import { StackNavigationProp } from '@react-navigation/stack';
import {
  Platform,
  createUseStyles,
  getAddress,
  useGetChatFindConversations,
  useGetChatGoToMessage,
  useLang,
  useTheme,
  userInfo,
} from 'core/src';
import { SocketIOContext } from '../../app/appcontainer';
import { MyBottomSheet } from '../../organisms';
import {
  changeText,
  loadEarlier,
  sendMessage,
  setIsEdited,
  editMessage,
  replyMessage,
  clear,
  forwardMessage,
  // searchText,
  editSeenAllMessage,
  Provider,
  Store,
  deleteMessage,
  getMessage,
  setMentions,
  clearMessage,
  setScrollData,
} from './store';
import { EmojiKeyboard, EmojiType } from 'rn-emoji-keyboard';
import {
  showBottomSheetUpdate,
  Store as BottomSheetStore,
} from '../../organisms/myBottomsheet/store';
import { useTranslation } from 'react-i18next';
import CustomActions from './example-expo/CustomActions';
import ZoomableImage from './example-expo/ZoomableImage';
import AskModal from './example-expo/AskModal';
// import { debounce } from 'lodash';
interface ChatProps {
  navigation: StackNavigationProp<any>;
  conversationId?: any;
  name: string;
  setOpen?: any;
  status: string;
  avatar?: any;
  unread?: number;
}

const MaterialCommunityIconsX =
  MaterialCommunityIcons as unknown as React.ComponentType<any>;
const MaterialIconsX = MaterialIcons as unknown as React.ComponentType<any>;
const FontAwesome5X = FontAwesome5 as unknown as React.ComponentType<any>;

const ChatScreen = ({
  conversationId,
  navigation,
  name,
  avatar,
  setOpen,
  status,
  unread,
}: ChatProps) => {
  const { styles, colors } = useStyles();
  const { userName, name: _name } = userInfo();
  const { theme } = useTheme();
  const [search, setSearch] = useState(false);
  const [emojiShow, setEmojiShow] = useState('');
  const [selectedItem, setSelectedItem] = useState<string[]>([]);
  const [selected, setSelected] = useState<boolean>(false);
  const [emojiKeyboardVisible, setEmojiKeyboardVisible] = useState(false);
  const { lang } = useLang();
  const dispatch = Store.useDispatch();
  const state = Store.useState();
  const dispatchBottomSheet = BottomSheetStore.useDispatch();
  const stateBottomShet = BottomSheetStore.useState();
  const [change, setChange] = useState(false);
  const [size, setSize] = useState(30);
  const [isTag, setIsTag] = useState(true);
  const [isEditable, setIsEditable] = useState(false);
  const { i18n } = useTranslation();
  const [modalVisible, setModalVisible] = useState(false);
  const [modalVisibleOption, setModalVisibleOption] = useState(false);
  const [modalVisibleSeens, setModalVisibleSeens] = useState(false);
  const [propsState, setPropsState] = useState(null);
  const [props2State, setProps2State] = useState(null);
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [scrollId, setScrollId] = useState('');
  const [socketData, setSocketData] = useState<any>([]);
  const [socketDataMessage, setSocketDataMessage] = useState<any>([]);
  const [fetchId, setFetchId] = useState<any>(null);
  const [isBot, setIsBot] = useState(true);
  const [getCounter, setGetCounter] = useState(0);
  const [countClick, setCountClick] = useState(0);
  const [highLight, setHighLight] = useState(false);
  const [highLightId, setHighLightId] = useState('');
  const [pinnedMessages, setPinnedMessages] = useState<any>([]);
  const [disableCount, setDisableCount] = useState(1);
  const [newMessageRecived, setNewMessageRecived] = useState('');
  const [liveStatus, setLiveStatus] = useState('');
  const [liveSituation, setLiveSituation] = useState('');
  const [optionsProps, setOptionsProps] = useState<any>(null);
  const [newAppendMessage, setNewAppendMessage] = useState<any[]>([]);
  const [deleteMessagelist, setDeleteMessageList] = useState<any[]>([]);
  const { data: chatInfoData } = useGetChatFindConversations(
    {
      pageNumber: '1',
      pageSize: '1',
      conversationId,
    },
    {
      retry: 0,
      refetchOnWindowFocus: false,
    },
  );

  const address = getAddress();

  function formatIranDate(date: any): string {
    if (!(date instanceof Date)) {
      return date;
    }

    const options = {
      calendar: 'persian',
      numberingSystem: 'arabext',
      year: 'numeric' as const,
      month: '2-digit' as const,
      day: '2-digit' as const,
      hour: '2-digit' as const,
      minute: '2-digit' as const,
      second: '2-digit' as const,
      hour12: false,
    };

    try {
      const formatter = new Intl.DateTimeFormat('fa-IR', options);
      const parts = formatter.formatToParts(date);

      const padTo2Digits = (num: any) => String(num).padStart(2, '0');

      const getPartValue = (type: string) => {
        const part = parts.find((p) => p.type === type);
        return part ? part.value : '00';
      };

      const persianToLatin = (str: string) =>
        str.replace(/[\u06F0-\u06F9]/g, (d) =>
          '۰۱۲۳۴۵۶۷۸۹'.indexOf(d).toString(),
        );

      const month = persianToLatin(padTo2Digits(getPartValue('month')));
      const day = persianToLatin(padTo2Digits(getPartValue('day')));
      const year = persianToLatin(getPartValue('year'));
      const hour = persianToLatin(padTo2Digits(getPartValue('hour')));
      const minute = persianToLatin(padTo2Digits(getPartValue('minute')));
      const second = persianToLatin(padTo2Digits(getPartValue('second')));

      const formattedDate = `${month}/${day}/${year}, ${hour}:${minute}:${second}`;

      return formattedDate;
    } catch (error) {
      console.error('Date formatting error:', error);
      return date.toString();
    }
  }

  const { data: searchData, refetch: refetchData } = useGetChatGoToMessage(
    {
      messageId: scrollId,
      conversationId,
    },
    {
      enabled: false,
      refetchOnWindowFocus: false,
      retry: 0,
    },
  );

  const getDynamicOffset = () => {
    const { height } = Dimensions.get('window');
    return height * 0.3;
  };

  useEffect(() => {
    Platform.isDesktop && setEmojiShow('');
    setSocketDataMessage([]);
  }, [conversationId]);

  useEffect(() => {
    if (Platform.isDesktop) {
      const gcLoadingContaineEl = document.querySelectorAll(
        '[data-testid="GC_LOADING_CONTAINER"]',
      )[0] as HTMLElement;
      if (gcLoadingContaineEl) {
        gcLoadingContaineEl.style.display = 'none';
        setTimeout(() => {
          gcLoadingContaineEl.style.display = 'flex';
        }, 500);
      }
    }

    function handleOnline() {
      setIsOnline(true);
    }

    function handleOffline() {
      setIsOnline(false);
    }

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      dispatch(clearMessage());
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  const handleModalCloseOption = () => {
    setModalVisibleOption(false);
  };

  const handleModalCloseSeens = () => {
    setModalVisibleSeens(false);
  };

  useEffect(() => {
    if (state.scrollData?.length > 0 && countClick > 0) {
      setTimeout(() => {
        goToIndexData(scrollId);
      }, 1000);
    }
  }, [state.scrollData, countClick]);

  const admins = chatInfoData?.data?.getOneMessageOfConversations[0].admins;
  const groupUsers =
    chatInfoData?.data?.getOneMessageOfConversations[0].participants?.map(
      (x: any) => x.user,
    );

  const isChannelAdmin = admins
    ?.map((item: any) => {
      return item?.user_name;
    })
    .includes(userName);

  useEffect(() => {
    if (chatInfoData?.data?.getOneMessageOfConversations[0]?.lastMessage?._id) {
      SocketIOContext.invoke('conversationMessages', {
        conversationId,
        unreadCount: fetchId ? 0 : unread,
        _id: fetchId
          ? fetchId.toString()
          : chatInfoData?.data?.getOneMessageOfConversations[0]?.lastMessage?._id.toString(),
      });
    }
  }, [chatInfoData, fetchId, unread]);

  useEffect(() => {
    //@ts-ignore
    if (unread > 0) {
      //@ts-ignore
      setNewMessageRecived(state.messages[unread - 1]);
    }
  }, [unread, state.messages]);

  SocketIOContext.useSocketEffect<any, any>(
    'getConversationMessages',
    (event: any): any => {
      setSocketData(event);

      if (fetchId) {
        setSocketDataMessage((prevMessages: any[]) => [
          ...newAppendMessage.reverse(),
          ...prevMessages,
          ...event?.messages.slice(1),
        ]);
      } else {
        setSocketDataMessage(event?.messages);
      }
    },
    [],
  );

  useEffect(() => {
    setPinnedMessages(socketData?.pinnedMessages);
  }, [socketData]);

  const ref = useRef<FlatList>();

  const [isTabActive, setIsTabActive] = useState(
    document.visibilityState === 'visible',
  );

  useEffect(() => {
    const handleVisibilityChange = () => {
      setIsTabActive(document.visibilityState === 'visible');
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);

  useEffect(() => {
    if (!userName) {
      console.warn('userName is undefined');
      return;
    }

    if (!Array.isArray(state.messages)) {
      console.warn('state.messages is not an array');
      return;
    }

    const messages = state.messages.filter(
      (x) =>
        userName &&
        !x?.seen_by?.includes(userName) &&
        x?.user?.userName !== userName,
    );

    const messageIds = messages?.map((item) => item.id);

    if (messageIds?.length > 0 && isTabActive) {
      SocketIOContext.invoke('seen', { conversationId, userName, messageIds });
    }
  }, [state.messages, userName, isTabActive]);

  SocketIOContext.useSocketEffect<any, any>(
    'sendSuccessMessage',

    (event: any): any => {
      ref.current?.scrollToOffset({
        animated: true,
        offset: 0,
      });
      dispatch(
        editMessage([
          {
            attachment: event?.message?.attachment,

            // type: event?.message?.attachment?.type,
            _id: event?.message?._id,
            client_id: event.message?.client_id,
            id: event?.message?.id,
            text: event?.message?.content,
            sent: true,
          },
        ]),
      );
    },
    [],
  );

  SocketIOContext.useSocketEffect<any, any>(
    'updateSituation',

    (event: any): any => {
      const checkStatus = groupUsers?.filter(
        (participant: any) => participant?.user_name === event?.username,
      );

      checkStatus && setLiveSituation(event?.situation);
    },
    [],
  );

  SocketIOContext.useSocketEffect<any, any>(
    'offline',

    (event: any): any => {
      const checkStatus = groupUsers?.filter(
        (participant: any) => participant?.user_name === event,
      );

      checkStatus && setLiveStatus('offline');
    },
    [],
  );

  SocketIOContext.useSocketEffect<any, any>(
    'online',

    (event: any): any => {
      const checkStatus = groupUsers?.filter(
        (participant: any) => participant?.user_name === event,
      );

      checkStatus && setLiveStatus('online');
    },
    [],
  );

  ///////////////////////////////

  SocketIOContext.useSocketEffect<any, any>(
    'seen',
    (event: any): any => {
      const messages = state?.messages?.findIndex(
        (item) => item?.received != true,
      );

      if (event?.conversationId === conversationId && messages !== -1) {
        dispatch(editSeenAllMessage());
      }
    },
    [conversationId],
  );

  ////////////////////////////////
  const onSend = async (messages: any[]) => {
    setEmojiShow('');
    setIsTag(false);
    setIsEditable(false);
    setSize(30);

    let file = {};
    if ((state.document || state.file) && state.uploadedFile) {
      file = String(state.uploadedFile?.data?.type).includes('image')
        ? {
            image: state.file?.assets?.[0]?.uri || state.document.uri,
          }
        : String(state.uploadedFile?.data?.type).includes('audio')
          ? {
              audio: state.file?.assets?.[0]?.uri || state.document.audio,
            }
          : String(state.uploadedFile?.data?.type).includes('pdf')
            ? {
                pdf: state.file?.assets?.[0]?.uri || state.document.uri,
              }
            : String(state.uploadedFile?.data?.fileName).includes('xlsx')
              ? {
                  xlsx: state.file?.assets?.[0]?.uri || state.document.uri,
                }
              : String(state.uploadedFile?.data?.fileName).includes(
                    'docx' || 'rtf',
                  )
                ? {
                    word: state.file?.assets?.[0]?.uri || state.document.uri,
                  }
                : {
                    otherFile:
                      state.file?.assets?.[0]?.uri ||
                      state.document.uri ||
                      state?.document?.uri,
                  };
    }
    const _id = generateUniqueRandomNumber(1000, 10000000);
    const createdAt = new Date();
    const tag = state.mentions?.map((username) => username.replace(/@/g, ''));

    const sentMessages = [
      {
        name: state.document?.assets?.[0]?.name,
        ...messages?.[0],
        ...(Boolean(state.replyMessage?.id) && {
          replyTo: {
            id: state.replyMessage?.id,
            content: state.replyMessage?.text,
            attachment: state.replyMessage?.attachment,
          },
        }),
        ...(Boolean(state.file) || (Boolean(state.document) && file)),
        _id,
        user: {
          _id: 1,
          name: _name,
          userName: userName,
        },
        createdAt: formatIranDate(createdAt),
        myCreatedAt: createdAt.toISOString(),
        tagged: tag,
        sent: false,
        received: false,
        pending: true,
      },
    ];

    setNewAppendMessage((prevMessages: any[]) => [
      ...prevMessages,
      ...sentMessages,
    ]);

    const newMessages = GiftedChat.prepend(
      state.messages,
      sentMessages,
      Platform.isWeb,
    );

    (messages?.[0]?.text.length > 0 || state.uploadedFile || state.mentions) &&
      dispatch(sendMessage(newMessages));
    SocketIOContext?.invoke('sendMessage', {
      conversationId,
      tagged: tag,
      _id,
      message: messages?.[0]?.text || ' ',
      originalMessageId: state.replyMessage?.id || null,
      ...(state.uploadedFile && { attachment: state.uploadedFile?.data }),
    });

    textInputRef?.current?.focus();
  };

  const handleForward = () => {
    dispatch(forwardMessage(optionsProps));
    dispatchBottomSheet(showBottomSheetUpdate(true));
  };

  const onGet = (messages: any) => {
    setGetCounter((counter) => counter + 1);

    const filterMessages = messages?.filter((message: any) => message?.id);

    const getMessages = filterMessages?.flatMap((item: any) => [
      {
        ...item,
        sent: true,
        received: false,
        pending: false,
      },
    ]);

    setNewAppendMessage((prevMessages: any[]) => [
      ...prevMessages,
      ...getMessages,
    ]);

    const newMessages = GiftedChat.prepend(
      state.messages,
      getMessages,
      Platform.isWeb,
    );

    const isValidShowMessage = newMessages?.filter(
      (message) => message.createdAt,
    );

    dispatch(getMessage(isValidShowMessage));
  };

  const onEdit = useCallback(
    (messages: any[]) => {
      setEmojiShow('');
      const createdAt = new Date();
      const editMessages = [
        {
          ...state.editingMessage,
          edited: true,
          myCreatedAt: createdAt.toISOString(),
          text: messages[0].text,
        },
      ];

      // setSocketDataMessage((prevMessages: any[]) => [
      //   ...newAppendMessage,
      //   ...editMessages,
      //   ...prevMessages,
      // ]);

      dispatch(editMessage(editMessages), () => {
        SocketIOContext?.invoke('editMessage', {
          messageId: state?.editingMessage?.id,
          content: messages[0]?.text,
        });
      });
      textInputRef?.current?.focus();
    },
    [dispatch, state.editingMessage],
  );

  SocketIOContext?.useSocketEffect<any, any>(
    'editMessage',
    (event: any) => {
      if (event.conversationId === conversationId) {
        dispatch(
          editMessage([
            {
              id: event?.message?.id,
              text: event?.message?.content,
            },
          ]),
        );

        // setSocketDataMessage((prevMessages: any[]) => [
        //   state.editingMessage,
        //   ...prevMessages,
        // ]);
      }
    },

    [conversationId, state.editingMessage],
  );

  const isAccess = socketData?.checkAccess;

  const onLoadEarlier = useCallback(() => {
    const myMessage =
      state.scrollData?.length > 0 ? state?.scrollData : socketDataMessage;

    const finalMessages1 = myMessage.filter(
      (item: any, index: any, self: any) =>
        self.findIndex((i: any) => i._id === item._id) === index &&
        !deleteMessagelist.includes(item.id),
    );

    const finalMessages2 = finalMessages1.sort(
      (a: any, b: any) => b._id - a._id,
    );

    const messages = finalMessages2?.map((item: any, index: number) => {
      let file = {};

      if (item?.attachment || item?.forward?.attachment) {
        file = String(item?.attachment?.type).includes('image')
          ? {
              image: `${address}/${item.attachment?.url}`,
            }
          : String(item?.forward?.attachment?.type).includes('image')
            ? {
                image: `${address}/${item?.forward?.attachment?.url}`,
              }
            : String(item?.attachment?.type).includes('audio')
              ? {
                  audio: `${address}/${item.attachment?.url}`,
                }
              : String(item?.forward?.attachment?.type).includes('audio')
                ? {
                    audio: `${address}/${item?.forward?.attachment?.url}`,
                  }
                : String(item?.attachment?.type).includes('pdf')
                  ? {
                      pdf: `${address}/${item.attachment?.url}`,
                    }
                  : String(item?.forward?.attachment?.type).includes('pdf')
                    ? {
                        pdf: `${address}/${item?.forward?.attachment?.url}`,
                      }
                    : String(item?.attachment?.url).includes('xlsx')
                      ? {
                          xlsx: `${address}/${item.attachment?.url}`,
                        }
                      : String(item?.forward?.attachment?.url).includes('xlsx')
                        ? {
                            xlsx: `${address}/${item?.forward?.attachment?.url}`,
                          }
                        : String(item?.attachment?.url).includes(
                              'docx' || 'rtf',
                            )
                          ? {
                              word: `${address}/${item.attachment?.url}`,
                            }
                          : String(item?.forward?.attachment?.url).includes(
                                'docx' || 'rtf',
                              )
                            ? {
                                word: `${address}/${item?.forward?.attachment?.url}`,
                              }
                            : {
                                otherFile: item?.forward
                                  ? `${address}/${item?.forward?.attachment?.url}`
                                  : `${address}/${item.attachment?.url}`,
                              };
      }

      const originalDate = item?.content
        ? new Date(item?.created_at)
        : new Date(item?.myCreatedAt);
      const iranDateTimeString = formatIranDate(originalDate);

      const text = item?.content ?? item?.text;

      return {
        name: item?.attachment?.url?.substring(36),
        text: item?.forward ? item?.forward?.content : text,
        user: {
          _id: item?.sender?._id ?? item?.user?._id,
          name: item?.sender?.name_and_family ?? item?.user?.name,
          userName: item?.sender?.user_name ?? item?.user?.userName,
        },
        ...file,
        // _id: index + 1,
        _id: item?._id,
        replyTo: item?.replied_to ?? item?.replyTo,
        createdAt: iranDateTimeString,
        id: item?.id,
        sent: item?.sent,
        received: item?.seen ?? item?.received,
        seen_by: item.seen_by,
        forward: item.forward,
        tagged: item.tagged,
        system: item?.content === '5040' ? true : false,
        edited: item?.edited,
        type: item?.attachment,
        highLight: highLight,
      };
    });

    // isOnline && !_isFetching && dispatch(loadEarlier(messages));
    isOnline && dispatch(loadEarlier(messages));
  }, [
    dispatch,
    state.messages,
    socketData,
    state.scrollData,
    socketDataMessage,
  ]);

  useEffect(() => {
    if (!socketData) return;
    onLoadEarlier();
  }, [socketData, state.scrollData, socketDataMessage]);

  const parsePatterns = useCallback((_linkStyle: any) => {
    return [
      {
        pattern: /#(\w+)/,
        style: { textDecorationLine: 'underline', color: 'blue' },
        onPress: () => Linking.openURL('http://gifted.chat'),
      },
    ];
  }, []);

  // const onLongPressAvatar = useCallback((pressedUser: any) => {
  //   Alert.alert(JSON.stringify(pressedUser));
  // }, []);

  // const onPressAvatar = useCallback(() => {
  //   Alert.alert('On avatar press');
  // }, []);

  // const setIsTyping = useCallback(
  //   (isTyping: boolean) => {
  //     dispatch(setIsTypingAction(isTyping));
  //   },
  //   [dispatch],
  // );

  const onSendFromUser = useCallback(
    (messages: IMessage[] = []) => {
      const createdAt = new Date();
      const messagesToUpload = messages.map((message) => ({
        ...message,
        user: {
          _id: 1,
          name: _name,
        },
        createdAt,
      }));
      ref.current?.scrollToOffset({
        animated: true,
        offset: 0,
      });

      onSend(messagesToUpload);
    },

    [
      onSend,
      state.messages,
      state.uploadedFile,
      state.file,
      state.document,
      state.mentions,
    ],
  );

  SocketIOContext.useSocketEffect<any, any>(
    'sendMessage',
    (event: any): any => {
      let file = {};
      // setConversationIdSocket(event?.conversationId);

      if (typeof event.conversationId === 'string') {
        if (event?.message?.attachment) {
          file = String(event?.message?.attachment.type).includes('image')
            ? {
                image: `${address}/${event?.message?.attachment?.url}`,
              }
            : String(event?.message?.attachment.type).includes('audio')
              ? {
                  audio: `${address}/${event?.message?.attachment?.url}`,
                }
              : String(event?.message?.attachment.type).includes('pdf')
                ? {
                    pdf: `${address}/${event?.message?.attachment?.url}`,
                  }
                : String(event?.message?.attachment?.url).includes('xlsx')
                  ? {
                      xlsx: `${address}/${event?.message?.attachment?.url}`,
                    }
                  : String(event?.message?.attachment?.url).includes(
                        'docx' || 'rtf',
                      )
                    ? {
                        word: `${address}/${event?.message?.attachment?.url}`,
                      }
                    : {
                        otherFile: `${address}/${event?.message?.attachment?.url}`,
                      };
        }
      } else {
        event.conversations?.flatMap((conversation: any) =>
          conversation?.messages?.flatMap((item: any) => {
            if (item?.forward?.attachment) {
              file = String(item?.forward?.attachment?.type).includes('image')
                ? {
                    image: `${address}/${item?.forward?.attachment?.url}`,
                  }
                : String(item?.forward?.attachment?.type).includes('audio')
                  ? {
                      audio: `${address}/${item?.forward?.attachment?.url}`,
                    }
                  : String(item?.forward?.attachment?.type).includes('pdf')
                    ? {
                        pdf: `${address}/${item?.forward?.attachment?.url}`,
                      }
                    : String(item?.forward?.attachment?.url).includes('xlsx')
                      ? {
                          xlsx: `${address}/${item?.forward?.attachment?.url}`,
                        }
                      : String(item?.forward?.attachment?.url).includes(
                            'docx' || 'rtf',
                          )
                        ? {
                            word: `${address}/${item?.forward?.attachment?.url}`,
                          }
                        : {
                            otherFile: `${address}/${item?.forward?.attachment?.url}`,
                          };
            }
          }),
        );
      }

      const originalDate = new Date(event?.message?.created_at);

      typeof event?.conversationId === 'string'
        ? onGet([
            event?.conversationId === conversationId && {
              name: event?.message?.attachment?.url
                ?.substring(36)
                .split('@@')?.[1],
              ...event?.message,
              _id: event?.message?._id,
              id: event?.message?.id,
              text: event.message?.content,
              createdAt: formatIranDate(originalDate),
              replyTo: event?.message?.replied_to,
              ...file,

              user: {
                _id: event?._id,
                name: event?.message.sender.name_and_family,
              },
            },
          ])
        : onGet(
            event?.conversations?.flatMap((conversation: any) =>
              conversation?.messages?.flatMap((item: any) => [
                conversation?.id === conversationId && {
                  // name: event?.message?.attachment?.url
                  //   .substring(36)
                  //   .split('@@')?.[1],
                  ...item,
                  _id: item?._id,
                  id: item?.id,
                  text: item?.forward?.content,
                  createdAt: formatIranDate(new Date(item?.created_at)),
                  // replyTo: event?.message?.replied_to,
                  ...file,

                  user: {
                    _id: event?._id,
                    name: item?.sender?.nameAndFamily,
                  },
                },
              ]),
            ),
          );
    },
    [],
  );

  const renderTimeAndEdit = useCallback((props: any) => {
    return (
      <>
        <Time
          currentMessage={props?.currentMessage}
          timeTextStyle={{ left: { color: colors.primaryColor } }}
        />
        {props.currentMessage.edited && (
          <MaterialIconsX name="edit" size={14} color={colors.primaryColor} />
        )}
      </>
    );
  }, []);

  const renderAccessory = useCallback(() => {
    return (
      <>
        <AccessoryBar
          onSend={onSendFromUser}
          onSendFile={onSend}
          {...{ conversationId }}
          setEmojiKeyboardVisible={setEmojiKeyboardVisible}
          generateUniqueRandomNumber={generateUniqueRandomNumber}
        />
      </>
    );
  }, [onSendFromUser]);

  const renderMessageAudio = useCallback((props: any) => {
    if (Platform.isPwa || Platform.isDesktop) {
      return (
        <audio style={styles.audio} controls>
          <source src={props?.currentMessage?.audio} />
        </audio>
      );
    }
    return null;
  }, []);

  const renderCustomActions = useCallback(
    (props: any) => {
      setIsTag(true);

      return chatInfoData?.data?.getOneMessageOfConversations[0]?.type ===
        'group' ? (
        <CustomActions
          {...props}
          onSend={onSendFromUser}
          iconTextStyle={{
            color: colors.secondryColor,
            margin: 5,
          }}
          groupUsers={groupUsers}
          setMentions={setMentions}
          isTag={isTag}
          dispatch={dispatch}
        />
      ) : null;
    },
    [onSendFromUser, chatInfoData, groupUsers, setMentions, isTag, dispatch],
  );

  const renderSystemMessage = useCallback((props: any) => {
    return (
      <>
        <SystemMessage
          {...props}
          containerStyle={{
            marginBottom: 15,
          }}
          textStyle={{
            fontSize: 14,
          }}
        />
      </>
    );
  }, []);

  const renderCustomView = (props: any) => {
    return (
      <>
        {Platform.isPwa ? (
          <View
            style={{
              padding: 2,
              flexDirection: 'row',
              justifyContent: 'flex-end',
            }}
          >
            <MaterialCommunityIconsX
              name="dots-horizontal"
              size={25}
              color={theme === 'white' ? 'black' : '#C0D6E8'}
            />
          </View>
        ) : (
          <Spacing vertical={4} />
        )}

        <View
          style={{
            backgroundColor: 'rgba(240, 240, 240,.5)',
            marginHorizontal: 20,
            display:
              props?.currentMessage.pdf ||
              props?.currentMessage.xlsx ||
              props?.currentMessage.word ||
              props?.currentMessage.otherFile
                ? 'flex'
                : 'none',
          }}
        >
          <Image
            source={
              props?.currentMessage.pdf
                ? require('../../../../assets/src/images/pdf-icon.png')
                : props?.currentMessage.xlsx
                  ? require('../../../../assets/src/images/exel.png')
                  : props?.currentMessage.word
                    ? require('../../../../assets/src/images/word.png')
                    : props?.currentMessage.otherFile &&
                      require('../../../../assets/src/images/ppt-icon.png')
            }
            resizeMode="contain"
            style={{
              width: 100,
              height: 80,
              alignSelf: 'center',
            }}
          />
          <Typography
            text={
              props?.currentMessage.pdf ||
              props?.currentMessage.xlsx ||
              props?.currentMessage.word ||
              props?.currentMessage.otherFile
                ? props?.currentMessage?.type?.url.split('@@')[1] ||
                  props?.currentMessage?.name
                : ' '
            }
            textAlign={'center'}
            classes={{ alignItems: 'center', marginLeft: 20, marginRight: 20 }}
          />
        </View>

        {props?.currentMessage?.tagged && (
          <View style={{ flexDirection: 'row', flexWrap: 'wrap' }}>
            {props?.currentMessage?.tagged?.map((tag: any, index: number) => (
              <View
                key={index}
                style={{
                  backgroundColor: '#EEF5FF',
                  opacity: 0.6,
                  padding: 10,
                  borderRadius: 20,
                  margin: 8,
                }}
              >
                <Typography color="blue" size={12} text={`@${tag}`} />
              </View>
            ))}
          </View>
        )}

        {props?.currentMessage?.forward && (
          <View style={{ flexDirection: 'row', flexWrap: 'wrap' }}>
            <View>
              <Typography
                color={theme === 'dark' ? '#CDC1FF' : 'blue'}
                classes={{ paddingHorizontal: 15, marginTop: 4 }}
                text={`${i18n.t('forwardBy')} ${props.currentMessage?.forward.sender.name_and_family}`}
              />
            </View>
          </View>
        )}
      </>
    );
  };

  const renderSend = useCallback(
    (props: SendProps<IMessage>) => {
      if (Boolean(state.editingMessage)) {
        return (
          <Send
            {...props}
            text={
              (state.file ||
                state.document ||
                state.mentions ||
                state.mentions ||
                state.uploadedFile) &&
              !props?.text
                ? ''
                : state?.text
            }
            containerStyle={{ justifyContent: 'center' }}
          >
            <MaterialIconsX
              size={30}
              color={colors.secondryColor}
              name={'check'}
              style={{
                transform: [
                  {
                    rotate:
                      lang === 'fa-IR' && Platform.isNative ? '180deg' : '0deg',
                  },
                ],
                padding: 2,
              }}
            />
          </Send>
        );
      } else if (state.document || state.file) {
        if (state.uploadedFile?.data?.status === 'success') {
          return (
            <Send
              {...props}
              text={props.text ? state?.text : ' '}
              containerStyle={{ justifyContent: 'center' }}
            >
              <MaterialIconsX
                size={30}
                color={colors.secondryColor}
                name={'send'}
                style={{
                  transform: [
                    {
                      rotate:
                        lang === 'fa-IR' && Platform.isNative
                          ? '180deg'
                          : '0deg',
                    },
                  ],
                  padding: 2,
                }}
              />
            </Send>
          );
        } else {
          return Platform.isDesktop ? (
            <Typography
              color="red"
              text={i18n.t('Uploading')}
              classes={{ padding: 20 }}
            />
          ) : (
            <ActivityIndicator size={'small'} />
          );
        }
      } else {
        return (
          <Send
            {...props}
            text={
              (state.file ||
                state.document ||
                state.mentions.length > 0 ||
                state.uploadedFile) &&
              !props?.text
                ? ' '
                : state.text
            }
            containerStyle={{ justifyContent: 'center' }}
          >
            <MaterialIconsX
              size={30}
              color={colors.secondryColor}
              name={'send'}
              style={{
                transform: [
                  {
                    rotate:
                      lang === 'fa-IR' && Platform.isNative ? '180deg' : '0deg',
                  },
                ],
                padding: 2,
              }}
            />
          </Send>
        );
      }
    },

    [
      state.editingMessage,
      state.file,
      state.document,
      state.uploadedFile,
      emojiShow,
      state.text,
      state.mentions,
    ],
  );

  const handleBubbleLongPress = (props: any) => {
    setSelected(true);
    setSelectedItem((prevList) => {
      return [...prevList, props?.currentMessage.id];
    });
  };

  const handleSelectPress = (props: any) => {
    setSelected(true);
    setSelectedItem((prevList) => {
      return [...prevList, props?.id];
    });
  };

  const handleEdit = useCallback((props: any, a: any) => {
    textInputRef?.current?.focus();
    setIsEditable(true);
    dispatch(setIsEdited(a));
    dispatch(changeText(a?.text));
  }, []);

  const handleDeleteGroup = (props: any, a: any) => {
    dispatch(deleteMessage(selectedItem), () => {
      SocketIOContext?.invoke('deleteMessage', {
        messageIds: selectedItem,
        conversationId: conversationId,
      });
      setSelectedItem([]);
      setSelected(false);
      setDeleteMessageList((prevMessages: any[]) => [
        ...prevMessages,
        ...selectedItem,
      ]);
    });
  };

  SocketIOContext.useSocketEffect<any, any>(
    'deleteMessage',
    (event: any) => {
      if (event.conversationId === conversationId) {
        dispatch(deleteMessage(event?.messagesInfo));
      }
      setDeleteMessageList((prevMessages: any[]) => [
        ...prevMessages,
        ...event?.messagesInfo,
      ]);
    },

    [],
  );

  const handlePin = (props: any, a: any) => {
    SocketIOContext.invoke('pinMessage', {
      conversationId: conversationId,
      messageId: a?.id,
      pinned: true,
    });
  };

  SocketIOContext.useSocketEffect<any, any>(
    'SuccessPinMessage',
    (event: any): any => {
      setPinnedMessages((prevMessages: any[]) => {
        const messageExists = prevMessages.some(
          (message) => message.id === event.message.id,
        );

        if (messageExists) {
          return prevMessages.filter(
            (message) => message.id !== event.message.id,
          );
        } else {
          return [...prevMessages, event.message];
        }
      });
    },
    [],
  );

  const onClosePin = (a: any) => {
    SocketIOContext.invoke('pinMessage', {
      conversationId: conversationId,
      messageId: a,
      pinned: false,
    });
  };

  const onClickPin = (a: any) => {
    setScrollId(a);
    setCountClick((countClick) => countClick + 1);
  };

  useEffect(() => {
    if (scrollId !== '') {
      refetchData();
    }
  }, [scrollId, refetchData]);

  useEffect(() => {
    dispatch(setScrollData(searchData?.data?.messages));
  }, [searchData]);

  const handleDownload = (props: any, a: any) => {
    const url =
      a?.attachment?.url ||
      a?.image ||
      a?.pdf ||
      a?.xlsx ||
      a?.word ||
      a?.otherFile;
    if (!url) return;

    function checkURL(url: any) {
      const domain = 'https://messenger.holding5040.ir';

      if (!url.startsWith(domain)) {
        Linking.openURL(`${address}/${url}`);
      } else {
        Linking.openURL(url);
      }
    }
    checkURL(url);
  };

  const handleClickMessage = (props: any, a: any) => {
    setIsBot(true);
    if (selected) {
      setSelectedItem((prevList) => {
        const index = prevList.indexOf(a?.id);
        if (index !== -1) {
          return prevList.filter((item) => item !== a?.id);
        } else {
          return [...prevList, a?.id];
        }
      });
    }
  };

  const renderDay = (props: any) => {
    return <Day {...props} textStyle={{ color: colors.primaryColor }} />;
  };

  function goToIndex(_id: any) {
    setHighLightId(_id);

    const index = state?.messages?.findIndex((item) => item.id === _id);

    if (index !== -1 && ref?.current?.props?.data?.length) {
      ref.current?.scrollToIndex?.({ animated: true, index, viewOffset: 200 });
    } else {
      setScrollId(_id);
      setCountClick((countClick) => countClick + 1);
    }
    setHighLight(true);
  }

  function goToIndexData(_id: any, retries = 3) {
    setHighLightId(_id);

    const index = state.scrollData?.findIndex((item) => item.id === _id);

    const scrollToIndexWithRetry = async (
      retryIndex: number,
      attempts: number,
    ) => {
      if (attempts <= 0) {
        console.log('scrollToIndex failed after retries');
        return;
      }

      try {
        const viewOffset = getDynamicOffset();
        console.log(
          `Attempting to scroll to index: ${retryIndex} with viewOffset: ${viewOffset}`,
        );
        ref.current?.scrollToIndex({
          animated: true,
          index: retryIndex,
          viewOffset,
        });
      } catch (error) {
        console.log(
          `scrollToIndex failed, retrying... (${attempts} attempts left)`,
          error,
        );
        await new Promise((resolve) => setTimeout(resolve, 500));
        await scrollToIndexWithRetry(retryIndex, attempts - 1);
      }
    };

    if (index !== -1 && ref?.current?.props?.data?.length) {
      scrollToIndexWithRetry(index, retries);
    } else {
      console.log('index Not Found or list is empty');
    }
    setHighLight(true);
  }

  setTimeout(() => {
    if (highLight) {
      setHighLight(false);
    }
  }, 3000);

  useEffect(() => {
    //@ts-ignore
    if (disableCount > 0 && newMessageRecived?.id) {
      setDisableCount((disableCount) => disableCount - 1);
      setTimeout(() => {
        //@ts-ignore
        goToIndex(newMessageRecived?.id);
      }, 1000);
    }
  }, [ref?.current?.props?.data?.length, newMessageRecived]);

  const renderBubble = (props: any) => {
    !search && Platform.isDesktop && textInputRef?.current?.focus();

    const { currentMessage } = props;
    const isSelected = selectedItem.includes(currentMessage?.id);
    const currentUser = currentMessage?.user?.userName === userName;
    const opacity = isSelected ? 0.5 : 1;

    const handleContextMenu = (event: any, messageProps: any) => {
      !Platform.isPwa && event.preventDefault();
      setOptionsProps(messageProps?.currentMessage);
      setModalVisibleOption(!modalVisibleOption);
    };

    if (currentMessage?.replyTo && currentMessage?.replyTo !== null) {
      return (
        <View
          style={{ marginTop: 15, width: Platform.isDesktop ? '60%' : '90%' }}
          //@ts-ignore
          onContextMenu={(e) =>
            Platform.isDesktop ? handleContextMenu(e, props) : ''
          }
        >
          <Button
            classes={{
              alignItems: currentUser ? 'flex-end' : 'flex-start',
            }}
            onClick={() => {
              goToIndex(currentMessage?.replyTo?.id);
            }}
          >
            {String(currentMessage.replyTo?.attachment?.type).includes(
              'pdf',
            ) ? (
              <Image
                source={require('../../../../assets/src/images/pdf-icon.png')}
                resizeMode="contain"
                style={{ width: 40, height: 40, opacity: 0.5 }}
              />
            ) : String(currentMessage.replyTo?.attachment?.type).includes(
                'image',
              ) ? (
              <Image
                source={{
                  uri: `${address}/${currentMessage.replyTo?.attachment?.url}`,
                }}
                resizeMode="contain"
                style={{ width: 50, height: 50, opacity: 0.5 }}
              />
            ) : String(currentMessage.replyTo?.attachment?.type).includes(
                'xlsx',
              ) ||
              String(currentMessage.replyTo?.attachment?.type).includes(
                'sheet',
              ) ? (
              <Image
                source={require('../../../../assets/src/images/exel.png')}
                resizeMode="contain"
                style={{ width: 40, height: 40, opacity: 0.6 }}
              />
            ) : String(currentMessage.replyTo?.attachment?.type).includes(
                'audio',
              ) ? (
              <Image
                source={require('../../../../assets/src/images/voice-messages.avif')}
                resizeMode="contain"
                style={{ width: 50, height: 50, opacity: 0.6 }}
              />
            ) : String(currentMessage.replyTo?.attachment?.type).includes(
                'docx',
              ) ||
              String(currentMessage.replyTo?.attachment?.type).includes(
                'rtf',
              ) ||
              String(currentMessage.replyTo?.attachment?.type).includes(
                'document',
              ) ? (
              <Image
                source={require('../../../../assets/src/images/word.png')}
                resizeMode="contain"
                style={{ width: 40, height: 40, opacity: 0.6 }}
              />
            ) : (
              <Typography
                color={theme === 'white' ? '#fff' : '#000'}
                classes={{
                  backgroundColor: theme === 'white' ? '#2C3E50' : '#EEF5FF',
                  opacity: 0.4,
                  padding: 5,
                  paddingHorizontal: 20,
                  borderRadius: 20,
                  marginBottom: 5,
                }}
                text={
                  currentMessage?.replyTo?.forward
                    ? currentMessage?.replyTo?.forward?.content?.substring(
                        0,
                        20,
                      ) + '...'
                    : currentMessage?.replyTo?.content
                      ? currentMessage?.replyTo?.content?.substring(0, 20) +
                        '...'
                      : '...'
                }
              />
            )}
          </Button>

          <Bubble
            {...props}
            containerStyle={{
              left: {
                fontFamily: 'IRANSans',
                backgroundColor:
                  highLight && props.currentMessage.id === highLightId
                    ? colors.secondryColorOpacity
                    : '',
              },
              right: {
                fontFamily: 'IRANSans',
                backgroundColor:
                  highLight && props.currentMessage.id === highLightId
                    ? colors.secondryColorOpacity
                    : '',
              },
            }}
            wrapperStyle={{
              left: {
                fontFamily: 'IRANSans',
                backgroundColor: colors.reciveChat,
                opacity,
                maxWidth: '100%',
              },
              right: {
                fontFamily: 'IRANSans',
                backgroundColor: theme === 'white' ? '#E1D7C6' : colors.menu,

                opacity,
                maxWidth: '100%',
              },
            }}
            textStyle={{
              left: {
                fontFamily: 'IRANSans',
                color: colors.leftBubble,
                lineHeight: 30,
              },
              right: {
                fontFamily: 'IRANSans',
                color: theme === 'white' ? 'black' : 'white',
                lineHeight: 30,
              },
            }}
            onLongPress={() => handleBubbleLongPress(props)}
            onPress={(e, a) =>
              (String(currentMessage?.type?.url).includes('pdf') ||
                String(currentMessage?.attachment?.url).includes('pdf') ||
                String(currentMessage?.type?.url).includes('docx') ||
                String(currentMessage?.attachment?.url).includes('docx') ||
                String(currentMessage?.type?.url).includes('xlsx') ||
                String(currentMessage?.attachment?.url).includes('xlsx') ||
                String(currentMessage?.type?.url).includes('sheet') ||
                String(currentMessage?.attachment?.url).includes('sheet') ||
                String(currentMessage?.type?.url).includes('rtf') ||
                String(currentMessage?.attachment?.url).includes('rtf') ||
                String(currentMessage?.type?.url).includes('document') ||
                String(currentMessage?.attachment?.url).includes('document')) &&
              !selected
                ? handleDownload(e, a)
                : selected
                  ? handleClickMessage(e, a)
                  : Platform.isPwa
                    ? handleContextMenu(e, props)
                    : ''
            }
            renderTime={renderTimeAndEdit}
          />
        </View>
      );
    } else {
      return (
        <View
          style={{
            marginTop: 15,

            width: Platform.isDesktop ? '60%' : '90%',
          }}
          //@ts-ignore
          onContextMenu={(e) =>
            Platform.isDesktop ? handleContextMenu(e, props) : ''
          }
        >
          <Bubble
            {...props}
            containerStyle={{
              left: {
                fontFamily: 'IRANSans',
                backgroundColor:
                  highLight && props.currentMessage.id === highLightId
                    ? colors.secondryColorOpacity
                    : '',
              },
              right: {
                fontFamily: 'IRANSans',
                backgroundColor:
                  highLight && props.currentMessage.id === highLightId
                    ? colors.secondryColorOpacity
                    : '',
              },
            }}
            wrapperStyle={{
              fontFamily: 'IRANSans',
              left: {
                backgroundColor: colors.reciveChat,
                opacity: opacity,
                maxWidth: '100%',
              },
              right: {
                fontFamily: 'IRANSans',
                backgroundColor: theme === 'white' ? '#E1D7C6' : colors.menu,
                opacity: opacity,
                maxWidth: '100%',
              },
            }}
            textStyle={{
              left: {
                fontFamily: 'IRANSans',
                color: colors.leftBubble,
                lineHeight: 30,
              },
              right: {
                fontFamily: 'IRANSans',
                color: theme === 'white' ? 'black' : 'white',
                lineHeight: 30,
              },
            }}
            renderTime={renderTimeAndEdit}
            onLongPress={() => handleBubbleLongPress(props)}
            onPress={(e, a) =>
              (String(currentMessage?.type?.url).includes('pdf') ||
                String(currentMessage?.attachment?.url).includes('pdf') ||
                String(currentMessage?.type?.url).includes('docx') ||
                String(currentMessage?.attachment?.url).includes('docx') ||
                String(currentMessage?.type?.url).includes('xlsx') ||
                String(currentMessage?.attachment?.url).includes('xlsx') ||
                String(currentMessage?.type?.url).includes('sheet') ||
                String(currentMessage?.attachment?.url).includes('sheet') ||
                String(currentMessage?.type?.url).includes('rtf') ||
                String(currentMessage?.attachment?.url).includes('rtf') ||
                String(currentMessage?.type?.url).includes('document') ||
                String(currentMessage?.attachment?.url).includes('document')) &&
              !selected
                ? handleDownload(e, a)
                : selected
                  ? handleClickMessage(e, a)
                  : Platform.isPwa
                    ? handleContextMenu(e, props)
                    : ''
            }
          />
        </View>
      );
    }
  };

  const renderInputToolbar = (props: any) => {
    if (
      chatInfoData?.data?.getOneMessageOfConversations[0]?.type === 'channel'
    ) {
      return isChannelAdmin ? (
        <InputToolbar
          {...props}
          containerStyle={{
            backgroundColor: colors.inputTollbar,
          }}
          placeholderTextColor={colors.secondryColor}
          placeholder={i18n.t('TypeAMessage') + '...'}
          textInputProps={{
            style: {
              fontFamily: 'IRANSans',
              color: theme === 'dark' ? 'white' : 'black',
              borderWidth: 0,
              borderColor: 'transparent',
              outlineStyle: 'none',
              width: '100%',
              paddingHorizontal: 10,

              height: size,
              fontSize: 15,
              direction: lang === 'fa-IR' ? 'rtl' : 'ltr',
            },
            maxLength: 2000,
          }}
        />
      ) : null;
    } else if (
      chatInfoData?.data?.getOneMessageOfConversations[0]?.type === 'group' ||
      chatInfoData?.data?.getOneMessageOfConversations[0]?.type ===
        'savedMessages'
    ) {
      return (
        <InputToolbar
          {...props}
          containerStyle={{
            backgroundColor: colors.inputTollbar,
          }}
          placeholderTextColor={colors.secondryColor}
          placeholder={i18n.t('TypeAMessage') + '...'}
          textInputProps={{
            style: {
              fontFamily: 'IRANSans',
              color: theme === 'dark' ? 'white' : 'black',
              borderWidth: 0,
              borderColor: 'transparent',
              outlineStyle: 'none',
              width: '100%',
              paddingHorizontal: 10,

              height: size,
              fontSize: 15,
              direction: lang === 'fa-IR' ? 'rtl' : 'ltr',
            },
            maxLength: 2000,
          }}
        />
      );
    } else {
      return isAccess ? (
        <InputToolbar
          {...props}
          containerStyle={{
            backgroundColor: colors.inputTollbar,
          }}
          placeholderTextColor={colors.secondryColor}
          placeholder={i18n.t('TypeAMessage') + '...'}
          textInputProps={{
            style: {
              fontFamily: 'IRANSans',
              color: theme === 'dark' ? 'white' : 'black',
              borderWidth: 0,
              borderColor: 'transparent',
              outlineStyle: 'none',
              width: '100%',
              paddingHorizontal: 10,
              height: size,
              fontSize: 15,
              direction: lang === 'fa-IR' ? 'rtl' : 'ltr',
            },
            maxLength: 2000,
          }}
        />
      ) : null;
    }
  };

  const renderFooter = useCallback(() => {
    setIsEditable(false);

    const replayText =
      state.replyMessage?.text || state.editingMessage?.text || '';
    const replyTextByLine =
      replayText?.split('\n')[0] +
      replayText?.split('\n')[1] +
      replayText?.split('\n')[2] +
      '...';
    const replay =
      replayText === ''
        ? ''
        : replayText.split('\n')?.length > 4
          ? replyTextByLine?.substring(0, 30) + '...'
          : replayText?.substring(0, 30) + '...';
    return (
      <View style={{ height: 'auto', backgroundColor: colors.inputTollbar }}>
        {(Boolean(state.replyMessage) ||
          Boolean(state.editingMessage) ||
          Boolean(state.file) ||
          Boolean(state.document)) && (
          <View
            style={{
              height: 'auto',
              backgroundColor: colors.inputTollbar,
              marginBottom: 15,
            }}
          >
            <Replay
              edit={isEditable}
              handleCloseReplay={() => {
                setIsEditable(false);
                dispatch(clear());
                setChange(true);
                setTimeout(() => {
                  setChange(false);
                }, 100);
              }}
            >
              {(state.file || state.document) && (
                <View
                  style={{
                    flexDirection: 'row',
                    display: 'flex',
                    justifyContent: 'space-around',
                    alignItems: 'center',
                  }}
                >
                  <View>
                    {state.document?.audio ? (
                      <audio style={styles.audio} controls>
                        <source src={state.document?.audio} />
                      </audio>
                    ) : String(state.document?.assets?.[0]?.type).includes(
                        'pdf',
                      ) ? (
                      <Image
                        source={require('../../../../assets/src/images/pdf-icon.png')}
                        resizeMode="contain"
                        style={{ width: 50, height: 50 }}
                      />
                    ) : String(state.document?.assets?.[0]?.name).includes(
                        'docx' || 'rtf',
                      ) ? (
                      <>
                        <Image
                          source={require('../../../../assets/src/images/word.png')}
                          resizeMode="contain"
                          style={{ width: 50, height: 50 }}
                        />
                      </>
                    ) : String(state.document?.assets?.[0]?.name).includes(
                        'xlsx',
                      ) ? (
                      <Image
                        source={require('../../../../assets/src/images/exel.png')}
                        resizeMode="contain"
                        style={{ width: 50, height: 50 }}
                      />
                    ) : String(state.document?.assets?.[0]?.name).includes(
                        'psd',
                      ) ? (
                      <Image
                        source={require('../../../../assets/src/images/photoShop.png')}
                        resizeMode="contain"
                        style={{ width: 50, height: 50 }}
                      />
                    ) : String(state.document?.assets?.[0]?.type).includes(
                        'image',
                      ) ? (
                      <>
                        <Image
                          source={{
                            uri:
                              state.file?.assets?.[0].uri ||
                              state.document?.uri,
                          }}
                          style={{ width: 50, height: 50 }}
                        />
                      </>
                    ) : (
                      <Image
                        source={require('../../../../assets/src/images/ppt-icon.png')}
                        resizeMode="contain"
                        style={{ width: 50, height: 50 }}
                      />
                    )}
                  </View>

                  <View>
                    <Typography text={state.document?.assets?.[0]?.name} />
                  </View>
                </View>
              )}
              <Typography text={replay || ''} />
            </Replay>
          </View>
        )}
        {state.mentions.length > 0 && (
          <View
            style={{
              flexDirection: 'row',
              backgroundColor: colors.inputTollbar,
              height: 60,
              alignItems: 'center',
            }}
          >
            {state.mentions?.map((tag) => (
              <View
                style={{
                  flexDirection: 'row',
                  height: '60%',
                  borderRadius: 20,
                  margin: 4,
                  padding: 10,
                  alignItems: 'center',
                  backgroundColor: 'rgba(239, 239, 240, 0.4)',
                }}
              >
                <Typography text={tag} />
              </View>
            ))}
          </View>
        )}
      </View>
    );
  }, [
    state.editingMessage,
    state.replyMessage,
    state.file,
    state.document,
    state.isTyping,
    state.mentions,
  ]);

  const textInputRef = useRef<any>(null);

  const ChatComposer = (
    props: ComposerProps & {
      onSend: SendProps<IMessage>['onSend'];
      text: SendProps<IMessage>['text'];
    },
  ) => {
    const onChangeText = (text: any) => {
      setTimeout(
        () => SocketIOContext.invoke('isTyping', { userName, conversationId }),
        500,
      );
      props?.onTextChanged?.(text);
      dispatch(changeText(text));
    };

    return (
      <Composer
        {...props}
        {...(change && { composerHeight: size })}
        textInputProps={{
          ...props.textInputProps,
          blurOnSubmit: Platform.isDesktop && true,
          multiline: true,
          autoFocus: Platform?.isDesktop && !search ? true : false,
          onChangeText: onChangeText,
          value: state.text + emojiShow,
          //@ts-ignore
          ref: textInputRef,
          onSubmitEditing: () => {
            setTimeout(() => {
              if (textInputRef.current) {
                !search && textInputRef?.current?.focus();
              }
            }, 100);
            const textToSend = (state.text + emojiShow).trim();
            if (textToSend && props.onSend) {
              props.onSend({ text: textToSend }, true);
            }
          },
        }}
      />
    );
  };

  const [isType, setIsType] = useState(false);

  SocketIOContext.useSocketEffect<any, any>(
    'isTyping',
    (event: any): any => {
      event?.conversationId === conversationId && setIsType(true);
    },
    [],
  );
  setTimeout(() => setIsType(false), 1000);

  const renderType = () => {
    return (
      <View style={{ height: 40 }}>
        <TypingIndicator isTyping={!!isType} />
      </View>
    );
  };

  const handleEmojiSelected = (emoji: EmojiType) => {
    setEmojiShow((prev) => prev + emoji.emoji);
    !search && textInputRef?.current?.focus();
  };

  const renderLoadEarlier = () => {
    if (state.messages[state.messages?.length - 1]?._id === 1) {
      return null;
    } else {
      return (
        <TouchableOpacity
          style={{
            backgroundColor: colors.color01,
            width: 130,
            display: 'flex',
            justifyContent: 'center',
            borderRadius: 10,
            alignItems: 'center',
            margin: 'auto',
          }}
          onPress={onLoadEarlier}
        >
          <MaterialCommunityIconsX name="reload" size={25} color={'#C0D6E8'} />
        </TouchableOpacity>
      );
    }
  };

  const renderMessageImage = (props: any) => {
    return <ZoomableImage imageUri={props.currentMessage.image} />;
  };

  const handleScroll = ({ nativeEvent }: any) => {
    const { contentOffset, contentSize, layoutMeasurement } = nativeEvent;

    const isAtBot = contentOffset.y <= 0;

    if (isAtBot) {
      setIsBot(true);
    } else {
      setIsBot(false);
    }

    if (contentOffset.y + layoutMeasurement.height >= contentSize.height) {
      console.log('Scrolled to bottom, last message:');

      setFetchId(state.messages[state.messages.length - 1]?._id);
    }
  };

  const myParticipant =
    chatInfoData?.data?.getOneMessageOfConversations[0]?.participants?.filter(
      (x: any) => x.user?.user_name !== userName,
    );

  return (
    <>
      <Container classes={{ direction: Platform.isNative ? 'rtl' : 'ltr' }}>
        <SafeAreaView style={styles.container}>
          <ChatHeader
            setCountClick={setCountClick}
            isPinned={
              chatInfoData?.data?.getOneMessageOfConversations[0]?.isPinned
            }
            situation={
              liveSituation !== '' &&
              chatInfoData?.data?.getOneMessageOfConversations[0]?.type ===
                'privateChat'
                ? liveSituation
                : chatInfoData?.data?.getOneMessageOfConversations[0]?.type ===
                    'privateChat' && myParticipant[0]?.user?.situation
            }
            serachData={searchData}
            selectedItems={scrollId}
            setSelectedItems={setScrollId}
            avatar={avatar}
            status={
              liveStatus !== '' &&
              chatInfoData?.data?.getOneMessageOfConversations[0]?.type ===
                'privateChat'
                ? liveStatus
                : status
            }
            setOpen={setOpen}
            openBottomSheet={() => {
              dispatchBottomSheet(showBottomSheetUpdate(true));
            }}
            handleDelete={handleDeleteGroup}
            longPress={selectedItem}
            setSearch={setSearch}
            search={search}
            name={name}
            navigation={navigation}
            conversationId={conversationId}
            isChannelAdmin={isChannelAdmin}
          />
          <Line />

          <ImageBackground
            source={
              theme === 'light'
                ? require('../../../../assets/src/images/light.jpg')
                : theme === 'rose'
                  ? require('../../../../assets/src/images/rose.jpg')
                  : theme === 'dark'
                    ? require('../../../../assets/src/images/dark.jpg')
                    : require('../../../../assets/src/images/white-2.png')
            }
            style={styles.content}
          >
            {selected && (
              <SelectedMessage
                number={selectedItem?.length}
                onClick={() => {
                  setSelected(false);
                  setSelectedItem([]);
                }}
              />
            )}

            {pinnedMessages?.length > 0 && (
              <Pin
                type={chatInfoData?.data?.getOneMessageOfConversations[0]?.type}
                isChannelAdmin={isChannelAdmin}
                messages={pinnedMessages}
                onClose={onClosePin}
                onClick={onClickPin}
              />
            )}

            {state.messages && (
              <GiftedChat
                renderUsernameOnMessage={
                  chatInfoData?.data?.getOneMessageOfConversations[0]?.type ===
                  'group'
                }
                renderSystemMessage={renderSystemMessage}
                alwaysShowSend
                renderChatFooter={renderFooter}
                showAvatarForEveryMessage={
                  chatInfoData?.data?.getOneMessageOfConversations[0]?.type !==
                  'privateChat'
                }
                renderActions={renderCustomActions}
                renderMessageImage={renderMessageImage}
                dateFormat={'YYYY/MM/DD'}
                renderFooter={renderType}
                renderComposer={ChatComposer}
                renderInputToolbar={renderInputToolbar}
                messages={state.messages}
                onSend={Boolean(state.editingMessage?.id) ? onEdit : onSend}
                shouldUpdateMessage={() => true}
                onInputTextChanged={(event) => {
                  const lineCount = event.split('\n')?.length;
                  if (lineCount > 1 && lineCount < 10) {
                    setSize(lineCount * 20);
                  } else {
                    setSize(30);
                  }
                  setChange(lineCount > 1);
                }}
                loadEarlier={true}
                onLoadEarlier={onLoadEarlier}
                renderLoadEarlier={renderLoadEarlier}
                listViewProps={{
                  ref: ref,
                  initialNumToRender: 10000,
                  scrollEnabled: Platform.isDesktop ? false : true,
                  scrollEventThrottle: 16,
                  onScroll: handleScroll,
                }}
                parsePatterns={parsePatterns}
                user={{ _id: 1, name: name }}
                renderMessageAudio={renderMessageAudio}
                renderAccessory={renderAccessory}
                renderDay={renderDay}
                renderCustomView={renderCustomView}
                renderSend={renderSend}
                timeTextStyle={{
                  left: { color: 'black' },
                  right: { color: 'black' },
                }}
                inverted={true}
                infiniteScroll
                renderBubble={renderBubble}
              />
            )}
            {!isBot && (
              <Button
                classes={{
                  width: 50,
                  height: 50,
                  backgroundColor: colors.dropdownContent,
                  position: 'absolute',
                  bottom: 100,
                  left: 20,
                  borderRadius: 50,
                  flexDirection: 'row',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
                onClick={() => {
                  ref.current?.scrollToOffset({
                    animated: true,
                    offset: 0,
                  });
                  setGetCounter(0);
                }}
              >
                {getCounter <= 0 ? (
                  <MaterialCommunityIconsX
                    name="chevron-down"
                    size={35}
                    color={theme === 'dark' ? 'white' : 'black'}
                  />
                ) : (
                  <Typography
                    text={getCounter}
                    color={theme === 'dark' ? 'white' : 'black'}
                    size={20}
                    weight={'bold'}
                  />
                )}
              </Button>
            )}

            {emojiKeyboardVisible && (
              <TouchableWithoutFeedback
                onPress={() => {
                  setEmojiKeyboardVisible(false);
                  emojiShow !== '' &&
                    dispatch(changeText(state.text + emojiShow));
                  setEmojiShow('');
                }}
              >
                <View style={styles.centeredContainer}>
                  <View style={styles.emojiKeyboardContainer}>
                    <EmojiKeyboard onEmojiSelected={handleEmojiSelected} />
                  </View>
                </View>
              </TouchableWithoutFeedback>
            )}
            <MyBottomSheet
              setSelect={setSelected}
              setSelectedItemX={setSelectedItem}
              message={[state?.forwardedMessage?.id]}
              messages={selectedItem}
              ModalClose={() => {
                dispatchBottomSheet(showBottomSheetUpdate(false));
              }}
              modalVisible={stateBottomShet.showBottomSheet}
            />
            <AskModal
              setDeleteMessageList={setDeleteMessageList}
              openAsk={modalVisible}
              setOpenAsk={setModalVisible}
              props2State={props2State}
              conversationId={conversationId}
              propsState={propsState}
            />
            <MyModal
              animationType={'none'}
              handleModalClose={handleModalCloseOption}
              modalVisible={modalVisibleOption}
              classesIn={styles.modalContentOption}
              classesOut={[styles.modalContainerOption, {}]}
            >
              <View>
                <View
                  style={{
                    backgroundColor: colors.dropdownContent,

                    paddingVertical: 5,
                    paddingHorizontal: 10,
                  }}
                >
                  <Button
                    flexDirection={lang === 'fa-IR' ? 'row-reverse' : 'row'}
                    //@ts-ignore
                    onClick={() => {
                      dispatch(replyMessage(optionsProps));
                      setModalVisibleOption(false);
                    }}
                  >
                    <MaterialIconsX
                      name="replay"
                      size={20}
                      color={
                        theme === 'rose' || theme === 'dark' ? 'white' : 'black'
                      }
                    />
                    <Spacing horizontal={5} />
                    <Typography
                      text={i18n.t('reply')}
                      color={
                        theme === 'rose' || theme === 'dark' ? 'white' : 'black'
                      }
                    />
                  </Button>
                </View>
                {!optionsProps?.forward &&
                  optionsProps?.user.userName === userName && (
                    <>
                      <Spacing vertical={5} />

                      <View
                        style={{
                          backgroundColor: colors.dropdownContent,

                          paddingVertical: 5,
                          paddingHorizontal: 10,
                        }}
                      >
                        <Button
                          flexDirection={
                            lang === 'fa-IR' ? 'row-reverse' : 'row'
                          }
                          //@ts-ignore
                          onClick={(e: any) => {
                            handleEdit(e, optionsProps);
                            setModalVisibleOption(false);
                          }}
                        >
                          <MaterialIconsX
                            name="edit"
                            size={20}
                            color={
                              theme === 'rose' || theme === 'dark'
                                ? 'white'
                                : 'black'
                            }
                          />
                          <Spacing horizontal={5} />
                          <Typography
                            text={i18n.t('edit')}
                            color={
                              theme === 'rose' || theme === 'dark'
                                ? 'white'
                                : 'black'
                            }
                          />
                        </Button>
                      </View>
                    </>
                  )}

                {!optionsProps?.forward && (
                  <>
                    <Spacing vertical={5} />
                    <View
                      style={{
                        backgroundColor: colors.dropdownContent,

                        paddingVertical: 5,
                        paddingHorizontal: 10,
                      }}
                    >
                      <Button
                        flexDirection={lang === 'fa-IR' ? 'row-reverse' : 'row'}
                        //@ts-ignore
                        onClick={() => {
                          handleForward();
                          setModalVisibleOption(false);
                        }}
                      >
                        <MaterialIconsX
                          name="forward"
                          size={20}
                          color={
                            theme === 'rose' || theme === 'dark'
                              ? 'white'
                              : 'black'
                          }
                        />
                        <Spacing horizontal={5} />
                        <Typography
                          text={i18n.t('forward')}
                          color={
                            theme === 'rose' || theme === 'dark'
                              ? 'white'
                              : 'black'
                          }
                        />
                      </Button>
                    </View>
                  </>
                )}

                {(optionsProps?.type ||
                  optionsProps?.word ||
                  optionsProps?.pdf ||
                  optionsProps?.xlsx ||
                  optionsProps?.audio ||
                  optionsProps?.otherFile ||
                  optionsProps?.image) && (
                  <>
                    <Spacing vertical={5} />
                    <View
                      style={{
                        backgroundColor: colors.dropdownContent,

                        paddingVertical: 5,
                        paddingHorizontal: 10,
                      }}
                    >
                      <Button
                        flexDirection={lang === 'fa-IR' ? 'row-reverse' : 'row'}
                        //@ts-ignore
                        onClick={(e: any) => {
                          handleDownload(e, optionsProps);
                          setModalVisibleOption(false);
                        }}
                      >
                        <MaterialIconsX
                          name="download"
                          size={20}
                          color={
                            theme === 'rose' || theme === 'dark'
                              ? 'white'
                              : 'black'
                          }
                        />
                        <Spacing horizontal={5} />
                        <Typography
                          text={i18n.t('download')}
                          color={
                            theme === 'rose' || theme === 'dark'
                              ? 'white'
                              : 'black'
                          }
                        />
                      </Button>
                    </View>
                  </>
                )}
                {optionsProps?.text !== ' ' && (
                  <>
                    <Spacing vertical={5} />
                    <View
                      style={{
                        backgroundColor: colors.dropdownContent,

                        paddingVertical: 5,
                        paddingHorizontal: 10,
                      }}
                    >
                      <Button
                        flexDirection={lang === 'fa-IR' ? 'row-reverse' : 'row'}
                        //@ts-ignore
                        onClick={() => {
                          Clipboard.setString(optionsProps?.text);
                          setModalVisibleOption(false);
                        }}
                      >
                        <MaterialIconsX
                          name="content-copy"
                          size={20}
                          color={
                            theme === 'rose' || theme === 'dark'
                              ? 'white'
                              : 'black'
                          }
                        />
                        <Spacing horizontal={5} />
                        <Typography
                          text={i18n.t('copy')}
                          color={
                            theme === 'rose' || theme === 'dark'
                              ? 'white'
                              : 'black'
                          }
                        />
                      </Button>
                    </View>
                  </>
                )}

                {optionsProps?.user.userName === userName && (
                  <>
                    <Spacing vertical={5} />
                    <View
                      style={{
                        backgroundColor: colors.dropdownContent,

                        paddingVertical: 5,
                        paddingHorizontal: 10,
                      }}
                    >
                      <Button
                        flexDirection={lang === 'fa-IR' ? 'row-reverse' : 'row'}
                        //@ts-ignore
                        onClick={(e: any) => {
                          setPropsState(e);
                          setProps2State(optionsProps);
                          setModalVisibleOption(false);
                          setModalVisible(true);
                        }}
                      >
                        <MaterialIconsX
                          name="delete"
                          size={20}
                          color={theme === 'rose' ? 'orange' : 'red'}
                        />
                        <Spacing horizontal={5} />
                        <Typography
                          text={i18n.t('delete')}
                          color={theme === 'rose' ? 'orange' : 'red'}
                        />
                      </Button>
                    </View>
                  </>
                )}

                <Spacing vertical={5} />
                <View
                  style={{
                    backgroundColor: colors.dropdownContent,

                    paddingVertical: 5,
                    paddingHorizontal: 10,
                  }}
                >
                  <Button
                    flexDirection={lang === 'fa-IR' ? 'row-reverse' : 'row'}
                    //@ts-ignore
                    onClick={(e: any) => {
                      handlePin(e, optionsProps);
                      setModalVisibleOption(false);
                    }}
                  >
                    <MaterialIconsX
                      name="push-pin"
                      size={20}
                      color={
                        theme === 'rose' || theme === 'dark' ? 'white' : 'black'
                      }
                    />
                    <Spacing horizontal={5} />
                    <Typography
                      text={i18n.t('pin')}
                      color={
                        theme === 'rose' || theme === 'dark' ? 'white' : 'black'
                      }
                    />
                  </Button>
                </View>
                <Spacing vertical={5} />
                <View
                  style={{
                    backgroundColor: colors.dropdownContent,

                    paddingVertical: 5,
                    paddingHorizontal: 10,
                  }}
                >
                  <Button
                    flexDirection={lang === 'fa-IR' ? 'row-reverse' : 'row'}
                    //@ts-ignore
                    onClick={() => {
                      handleSelectPress(optionsProps);
                      setModalVisibleOption(false);
                    }}
                  >
                    <MaterialIconsX
                      name="select-all"
                      size={20}
                      color={
                        theme === 'rose' || theme === 'dark' ? 'white' : 'black'
                      }
                    />
                    <Spacing horizontal={5} />
                    <Typography
                      text={i18n.t('select')}
                      color={
                        theme === 'rose' || theme === 'dark' ? 'white' : 'black'
                      }
                    />
                  </Button>
                </View>
                {(chatInfoData?.data?.getOneMessageOfConversations[0]?.type ===
                  'group' ||
                  chatInfoData?.data?.getOneMessageOfConversations[0]?.type ===
                    'channel') &&
                  optionsProps?.user.userName === userName && (
                    <>
                      <Spacing vertical={5} />
                      <View
                        style={{
                          backgroundColor: colors.dropdownContent,

                          paddingVertical: 5,
                          paddingHorizontal: 10,
                        }}
                      >
                        <Button
                          flexDirection={
                            lang === 'fa-IR' ? 'row-reverse' : 'row'
                          }
                          //@ts-ignore
                          onClick={() => {
                            setModalVisibleOption(false);
                            setModalVisibleSeens(true);
                          }}
                        >
                          <MaterialIconsX
                            name="remove-red-eye"
                            size={20}
                            color={
                              theme === 'rose' || theme === 'dark'
                                ? 'white'
                                : 'black'
                            }
                          />
                          <Spacing horizontal={5} />
                          <Typography
                            text={i18n.t('seenBy')}
                            color={
                              theme === 'rose' || theme === 'dark'
                                ? 'white'
                                : 'black'
                            }
                          />
                        </Button>
                      </View>
                    </>
                  )}

                <Spacing vertical={5} />
              </View>
            </MyModal>

            <MyModal
              animationType={'fade'}
              handleModalClose={handleModalCloseSeens}
              modalVisible={modalVisibleSeens}
              classesIn={styles.modalContentSeens}
              classesOut={styles.modalContainerOption}
            >
              <ScrollingView>
                <View style={{ flexDirection: 'column' }}>
                  {[...new Set(optionsProps?.seen_by)]?.map((user: any) => (
                    <View style={{ flexDirection: 'row', margin: 10 }}>
                      <FontAwesome5X
                        name="user-check"
                        size={20}
                        color={
                          theme === 'rose' || theme === 'dark'
                            ? 'white'
                            : 'black'
                        }
                      />
                      <Spacing horizontal={5} />
                      <Typography
                        text={user}
                        color={
                          theme === 'rose' || theme === 'dark'
                            ? 'white'
                            : 'black'
                        }
                      />
                    </View>
                  ))}
                </View>
              </ScrollingView>
            </MyModal>
          </ImageBackground>
        </SafeAreaView>
      </Container>
    </>
  );
};

const useStyles = createUseStyles(({ colors, theme }) => ({
  container: { flex: 1 },
  content: { flex: 1, resizeMode: 'cover' },
  option: {
    padding: 12,
    borderBottomWidth: 1,
    borderBottomColor: colors.line,
  },
  fileView: {
    margin: 'auto',
    padding: 10,
  },
  modalContainer: {
    backgroundColor: 'rgba(0, 0, 0, 0.1)',
  },
  modalContainerOption: {
    backgroundColor: 'rgba(0, 0, 0, 0.3)',
    alignItems: 'center',
    justifyContent: 'center',
  },
  modalContentOption: {
    width: 200,
  },

  modalContentSeens: {
    width: 200,
    height: 200,
  },

  contentContainer: {
    flex: 1,
    alignItems: 'center',
    backgroundColor: 'white',
    position: 'absolute',
    left: 0,
    right: 0,
    bottom: 0,
    top: 0,
  },
  modalContent: {
    width: 160,
    height: 250,
  },
  audio: {
    width: 240,
    height: 45,
  },
  centeredContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    position: 'absolute',
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.1)',
  },
  emojiKeyboardContainer: {
    width: '70%',
    height: 450,
  },
  inputText: {
    color: '#fff',
    width: '100%',
    fontSize: Platform.isDesktop ? 18 : 16,
  },
}));

const ChatScreenContainer = memo<ChatProps>(
  ({ conversationId, navigation, name, setOpen, status, avatar, unread }) => {
    return (
      <Provider>
        <ChatScreen
          {...{
            conversationId,
            navigation,
            name,
            setOpen,
            status,
            avatar,
            unread,
          }}
        ></ChatScreen>
      </Provider>
    );
  },
);

export { ChatScreenContainer as ChatScreen };

var generatedNumbers = new Set();

function generateUniqueRandomNumber(min: number, max: number) {
  if (max - min + 1 <= generatedNumbers.size) {
    throw new Error(
      'All possible unique numbers within the range have been generated.',
    );
  }

  var randomNumber;
  do {
    randomNumber = Math.floor(Math.random() * (max - min + 1)) + min;
  } while (generatedNumbers.has(randomNumber));

  return randomNumber;
}
